module.exports = __webpack_public_path__ + "1c0ef5021b62934a97175851d3a433de.png";